import { createRouter, createWebHashHistory  } from 'vue-router'
import Home from '../views/Home.vue'
import Disclaimer from '../views/Disclaimer.vue';

import accountRoutes from './accountRoutes';
import usersRoutes from './usersRoutes';
import rolesRoutes from './rolesRoutes';
import appsRoutes from './appsRoutes';
import errorsRoutes from './errorsRoutes';


const routes = [ 
  
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }, 
  }, 

  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer,
    meta: { requiresAuth: true },
  },

  ...accountRoutes,
  ...usersRoutes,
  ...rolesRoutes,
  ...appsRoutes,
  ...errorsRoutes,
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// Verificación de rutas protegidas
router.beforeEach((to, from, next) => {

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  // Verificar autenticación
  if (to.meta.requiresAuth && !token) {

    next("/login");    
  }
  
  // Verificar permisos

  // valida si es super usuario
  if (user && user.role_name == 'Admin') { 

    // console.log('Es ADM');
    next();// Continuar con la navegación
    return;    
  }

  if (to.meta.permissions && user) {

    const hasPermission = to.meta.permissions.some((permission) =>
      // user.permissions.includes(permission)
      user.permissions.some(p => p.codename == permission)
    );

    if (!hasPermission) {
      
      next("/forbidden"); // Redirigir si no tiene permisos
      return;
    }
  }

  next(); // Continuar con la navegación
});

export default router;
